import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import httpHandler from "../utils/httpHandler";

export const getLocations = createAsyncThunk<
  string[],
  void,
  { rejectValue: string }
>("common/getStates", async (_, { rejectWithValue }) => {
  try {
    const response = await httpHandler.instanceAxios.get<string[]>(
      `${import.meta.env.VITE_SL3_URL}/api/Lookup/USStates`
    );
    return response.data;
  } catch (e) {
    const error = e as AxiosError;
    return rejectWithValue(error.message);
  }
});

export interface CommonState {
  options: string[];
  status: "" | "pending" | "fulfilled" | "rejected";
}

export const initialState: CommonState = {
  options: [],
  status: "",
};

const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocations.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.options = action.payload;
      })
      .addCase(getLocations.rejected, (state) => {
        state.status = "rejected";
      });
  },
});

export default commonSlice.reducer;
